import { Layers } from "appworks/graphics/layers/layers";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { gameLayers } from "game-layers";

export class FowlEnterBaseGameState extends State {
    public onEnter(cascadeSkip?: boolean): void {
        new Sequence([
            () => gameLayers.ScreenFade.setScene("black"),
            () => Contract.wrap(() => {
                Layers.resetLayerOrder();
                uiFlags.set(UIFlag.BONUS, false);
            }),
            () => gameLayers.BackgroundPersistentAnimation.defaultScene(),
            () => gameLayers.BackgroundIntermittentAnimation.defaultScene(),
            () => gameLayers.ScreenFade.defaultScene()
        ]).then(() => this.complete());
    }
}
